export default __webpack_public_path__ + "static/media/renzo-trujillo.54c9e868.png";